@if (loading) {
  <div class="loader"></div>
}

@if (view == 'add-holiday') {
  <app-add-holiday
    [project]="currentProject"
    (closeView)="changeView('home')"
    (notify)="loadData()">
  </app-add-holiday>
}

@if (view == 'edit-holiday') {
  <app-add-holiday
    [holiday]="selectedItem"
    [project]="currentProject"
    (closeView)="changeView('home')"
    (notify)="loadData()">
  </app-add-holiday>
}

@if (view == 'duplicate-holiday') {
  <app-add-holiday
    [holiday]="selectedItem"
    [duplicate]="true"
    [project]="currentProject"
    (closeView)="changeView('home')"
    (notify)="loadData()">
  </app-add-holiday>
}

@if (view == 'delete-holiday') {
  <app-confirm-window
    [title]="'Delete holiday'"
    [subtitle]="'Are you sure you want to delete this holiday'"
    (closeView)="changeView('home')"
    (confirm)="deleteHoliday();">
  </app-confirm-window>
}


<div class="main-wrapper">

  @if (selectedItem && _gS.showContext) {
    <div class="contextmenuConteiner" (click)="_gS.hidemenu()"  (contextmenu)="_gS.hidemenu()">
      <div class="contextmenu" [style.left]="_gS.contextmenux" [style.top]="_gS.contextmenuy">
        <ul>
          @if (_gS.validateAcces({id:1, type:'write'})) {
            <li (click)="changeView('edit-holiday')">{{'Edit' | translate}}</li>
          }
          @if (_gS.validateAcces({id:1, type:'write'})) {
            <li (click)="changeView('delete-holiday')">{{'Delete' | translate}}</li>
          }
          @if (_gS.validateAcces({id:1, type:'write'})) {
            <li (click)="changeView('duplicate-holiday')">{{'Duplicate' | translate}}</li>
          }
        </ul>
      </div>
    </div>
  }

  @if (!loading) {
    <div class="header">
      <div class="breadcrump">
        <ul>
          <li [routerLink]="['/home']">{{'Home' | translate}}</li>
          @if (currentProject) {
            <li [routerLink]="['/projects']">{{'Projects' | translate}}</li>
            <li [routerLink]="['/projects', currentProject.id]">{{currentProject.title}}</li>
            @if (module.name == 'post') {
              <li [routerLink]="['/projects', currentProject.id, 'post']">
              {{'Post-production' | translate }}</li>
            }
          }
        </ul>
      </div>
      <div class="page-tittle">
        <h1>{{'Holidays' | translate}}</h1>
        <div class="buttons">
          <a (click)="goBack()">{{'Go back' | translate}}</a>
          <a (click)="changeView('add-holiday')">{{'Add' | translate}}</a>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="L-12 M-12 S-12 columns">
        <div class="XL-2 L-3 M-3 S-4 columns search-wrapper">
          <input type="text" class="search" placeholder="{{'Search' | translate}}" [(ngModel)]="filterArguments.search"
            name="search" (blur)="filter()">
        </div>
      </div>
    </div>
    <div class="row wrapper-content">
      @if (!filteredHolidays.length) {
        <div class="noDataToShow">
          {{'There are no results to show' | translate}}
        </div>
      }
      @if (filteredHolidays.length) {
        <app-table
          [headers]="headers"
          [list]="filteredHolidays"
          [pagination]="true"
          [height100]="true"
          [noMargin]="true"
          [paginationOptions]="paginationOptions"
          [showMobileMenu]="true"
          (contextClick)="contextItem($event)"
          (onChangePagination)="_gS.savePagination($event, paginationOptions)">
        </app-table>
      }
    </div>
  }
</div>